<template>
  <button
    class="dev-panel-trigger"
    :class="{ 'has-active': activeCount > 0 }"
    @click="$emit('toggle')"
    :title="`Toggle Dev Panel (Ctrl+Shift+D)${activeCount > 0 ? ` - ${activeCount} active` : ''}`"
  >
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
      <path
        d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1Z"
      />
    </svg>
    <span v-if="activeCount > 0" class="badge">{{ activeCount }}</span>
  </button>
</template>

<script setup lang="ts">
defineProps<{
  activeCount: number;
}>();

defineEmits<{
  (e: "toggle"): void;
}>();
</script>

<style scoped>
.dev-panel-trigger {
  position: fixed;
  bottom: 20px;
  left: 70px; /* Offset to avoid Avo's FAB */
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: linear-gradient(135deg, #1e1e2e 0%, #2d2d3d 100%);
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: #b0b0c0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  z-index: 99999999;
}

.dev-panel-trigger:hover {
  background: linear-gradient(135deg, #2d2d3d 0%, #3d3d4d 100%);
  color: #ffffff;
  transform: scale(1.05);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
}

.dev-panel-trigger.has-active {
  background: linear-gradient(135deg, #1e3a5f 0%, #2d4a6f 100%);
  border-color: rgba(59, 130, 246, 0.3);
}

.dev-panel-trigger svg {
  width: 22px;
  height: 22px;
}

.badge {
  position: absolute;
  top: -4px;
  right: -4px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  border-radius: 9px;
  font-size: 11px;
  font-weight: 600;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 6px rgba(59, 130, 246, 0.4);
}
</style>


